import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import dayjs from "dayjs";
import { money } from "./boleteraHelper";

/*
  Corte parcial o total en pantalla, con el desglose por tipo de tarifa. Igual que el
  boleto, es HTML imprimible: el operador lo entrega junto con el efectivo.
*/
const CorteComprobante = ({ corte, salida, operador, onClose }) => {
  const imprimir = () => window.print();
  const titulo = corte?.tipo === "parcial" ? "Corte parcial" : "Corte total";
  const desglose = corte?.desglose ?? [];

  return (
    <Modal isOpen={!!corte} toggle={onClose} centered>
      {corte && (
        <>
          <ModalHeader toggle={onClose}>{titulo}</ModalHeader>
          <ModalBody>
            <div id="boletera-corte" className="boletera-comprobante">
              <div style={{ textAlign: "center", marginBottom: 10 }}>
                <div style={{ fontWeight: 700, fontSize: "15px" }}>{titulo}</div>
                <div style={{ fontSize: "11.5px", color: "#777a89" }}>
                  {salida?.ramal_nombre} · Unidad {salida?.unidad ?? "-"}
                </div>
              </div>

              {operador && (
                <div className="boletera-comprobante-row">
                  <span>Operador</span>
                  <span>{operador}</span>
                </div>
              )}
              <div className="boletera-comprobante-row">
                <span>Día</span>
                <span>{dayjs(corte.dia).format("DD/MM/YYYY")}</span>
              </div>
              <div className="boletera-comprobante-row">
                <span>Periodo</span>
                <span>
                  {dayjs(corte.desde).format("HH:mm")} – {dayjs(corte.hasta).format("HH:mm")}
                </span>
              </div>

              <hr />

              {desglose.length ? (
                <>
                  <div className="boletera-comprobante-row" style={{ fontWeight: 600, color: "#777a89" }}>
                    <span style={{ flex: 1 }}>Tipo</span>
                    <span style={{ width: 60, textAlign: "right" }}>Boletos</span>
                    <span style={{ width: 90, textAlign: "right" }}>Importe</span>
                  </div>
                  {desglose.map((d) => (
                    <div key={d.fare_type_id} className="boletera-comprobante-row">
                      <span style={{ flex: 1 }}>{d.tipo}</span>
                      <span style={{ width: 60, textAlign: "right" }}>{d.boletos}</span>
                      <span style={{ width: 90, textAlign: "right" }}>{money(d.importe)}</span>
                    </div>
                  ))}
                </>
              ) : (
                <div style={{ textAlign: "center", color: "#777a89" }}>Sin ventas en este corte</div>
              )}

              <hr />

              <div className="boletera-comprobante-row" style={{ fontSize: "16px", fontWeight: 700 }}>
                <span style={{ flex: 1 }}>Total</span>
                <span style={{ width: 60, textAlign: "right" }}>{corte.boletos}</span>
                <span style={{ width: 90, textAlign: "right" }}>{money(corte.total)}</span>
              </div>
              <div style={{ textAlign: "center", fontSize: "10.5px", color: "#777a89", marginTop: 10 }}>
                {corte.ventas} venta(s) · impreso {dayjs().format("DD/MM/YYYY HH:mm")}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={imprimir}>
              <i className="fa fa-print"></i> Imprimir
            </Button>
            <Button color="secondary" onClick={onClose}>
              <i className="fa fa-times"></i> Cerrar
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default CorteComprobante;
